import { BaseTag }   from "mixs/base/base_mixin";
import ConnectController from './connect_controller';
import {
  APPROVAL_CLICK_REQUIRE,
  GOTO_COMMENT_FORM
} from 'apps/events';
// required   スタンプを押すことを要請されている
// done       スタンプがすでに押してある
// enable　   自分がスタンプを押す、または削除することが可能
//
class ApprovalStamp extends BaseTag {
  connectController: ConnectController;
  stamp: HTMLElement;
  init(){
    super.init();
    this.watch();
    this.connectController  = new ConnectController(this);
    this.listenMount([this.onMountStamp]);
  }
  onMountStamp() {
    $(this.rootElement).find('[data-toggle="tooltip"]').tooltip('show');
  }
  onClickDestroy(){
    this.connectController.destroy(this.opts.payload);
  }
  onClickCreate(){
    $(this.rootElement).find('[data-toggle="tooltip"]').tooltip('hide');
    this.connectController.create(this.opts.payload);
  }
  onClickRequire(){
    let customEvent = new CustomEvent(APPROVAL_CLICK_REQUIRE, { detail: this.opts } );
    document.dispatchEvent(customEvent);
    let customEvent2 = new CustomEvent(GOTO_COMMENT_FORM, { detail: this.opts } );
    document.dispatchEvent(customEvent2);
  }
  clickable(){
    if(!this.opts.enable){ return false; }
    if(!this.opts.payload){ return false; };
    if(this.opts.done){
      if(!this.opts.cancelable){ return false; }
    }
    return true
  }
}
riot.mixin('orders.approvals.stamp', ApprovalStamp as riot.TagMixin);
